import { useEndpointFetch } from '../network/useEndpointFetch';

export const useVerifyEmailFetch = () => {
  return useEndpointFetch<{ hash: string; email: string }, { verified: boolean }>('/im/user/email/verify', {
    withAuth: false,
  });
};
